import {getSnapshot} from 'mobx-state-tree';
import _ from 'lodash';

const isEmptyText = (value) => { return !/\w+/.test(value); };
const isNullOrUndefined = (value) => { return value === null || value === undefined; };
const isEmptyArray = (value) => { return value.length <= 0; };

class FormUtilsService {

  radioGroupIsInvalid(required, value) {
    return required && isEmptyText(value);
  }

  checkboxGroupIsInvalid(required, value) {
    return required && isEmptyArray(value);
  }

  selectMenuIsInvalid(required, value) {
    return required && (isNullOrUndefined(value) || isEmptyText(value));
  }

  multiSelectIsInvalid(required, value) {
    return required && isEmptyArray(value);
  }

  textInputIsInvalid(type, required, value) {
    if(required && isEmptyText(value)) return true;
    if(type === 'TEXT_EMAIL') {
      //allowed emails are based on https://blogs.msdn.microsoft.com/testing123/2009/02/06/email-address-test-cases/
      //FPSE-2227 -> Updated to support multiple subdomains
      const emailRegex = /^([A-Z|a-z|0-9|_-](\.|\+){0,1})+[A-Z|a-z|0-9|_-]@([\w-]+\.)+?([\w]{2,})(:\d+)?(\/\S*)?$/gm;
      return !emailRegex.test(value);
    } else if(type === 'TEXT_NUMERIC') {
      const numericRegex = /^[0-9]*$/;
      return !numericRegex.test(value);
    } else if(type === 'TEXT_WEBSITE') {
      // FPSE-1821 (from AppControl) and FPSE-3149 : URL now has: required http, optional s, reqired ://, at least one character or dash followed by a . (the (sub)domains), string of at least 2 characters long (TLD), an optional port, and any number of "/digits" for routes
      const urlRegex = /^((https?:\/\/)([\w-]+\.)+?([\w]{2,})(:\d+)?(\/\S*)?)$/i;
      return !urlRegex.test(value);
    } else if(type === 'TEXT_ATTID') {
      const attIdRegex = /^[a-zA-Z0-9]{6}$/;
      return !attIdRegex.test(value);
    }
    return false;
  }

  cast(value, forceToType, fallbackValue = undefined) {
    if(forceToType === 'number') {
      if(value) {
        value = parseInt(value);
      } else {
        value = fallbackValue;
      }
    }
    return value;
  }

  cloneToPlainObject(model) {
    const snapshot = getSnapshot(model);
    return _.cloneDeep(snapshot);
  }

  createMutableModel(modelType, stateToClone, identifier = 'id', cloneIdentifier = 'MUTABLE') {
    let mutableSnap = stateToClone
      ? this.cloneToPlainObject(stateToClone)
      : {};
    mutableSnap[identifier] = cloneIdentifier;
    return modelType.create(mutableSnap);
  }
}

export const formUtilsService = new FormUtilsService();
